export default __webpack_public_path__ + "static/duo-mobile-d18f125e28711c5506676d194074c9e6.jpg";